import { State, Action, StateContext } from '@ngxs/store';
import { SetIsMenuOpenAction } from './view.actions';
import { Injectable } from '@angular/core';

export interface ViewStateModel {
  isMenuOpen: boolean;
}

@State<ViewStateModel>({
  name: 'view',
  defaults: {
    isMenuOpen: false,
  },
})
@Injectable()
export class ViewState {
  @Action(SetIsMenuOpenAction)
  public setIsMenuOpen({ patchState }: StateContext<ViewStateModel>, { isMenuOpen }: SetIsMenuOpenAction) {
    patchState({ isMenuOpen });
  }
}
